import { createMultiStyleConfigHelpers as e } from "@chakra-ui/react";
import { FileUploaderAnatomy as r } from "./FileUploader.anatomy.es.js";
const { defineMultiStyleConfig: o, definePartsStyle: i } = e(
  r.keys
), n = i({
  container: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    justifyContent: "flex-end"
  },
  content: {
    display: "flex",
    gap: "spacing-100",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    flex: "1 0 0",
    alignSelf: "stretch"
  },
  description: {
    lineHeight: "4.876",
    fontSize: "md",
    color: "primary.400",
    textAlign: "center"
  },
  descriptionContainer: {
    display: "flex",
    gap: "spacing-25",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  },
  drag: {
    transition: "background-color 150ms ease-out",
    _hover: {
      backgroundColor: "primary.100",
      borderStyle: "solid"
    },
    backgroundColor: "primary.50",
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: "primary.300"
  },
  dropzone: {
    padding: "spacing-200",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDir: "column",
    height: "full",
    width: "full",
    borderRadius: "lg",
    backgroundColor: "white",
    minWidth: "16.25rem",
    minHeight: "13.75rem",
    transition: "background-color 150ms ease-out",
    _hover: {
      backgroundColor: "neutral.100",
      borderStyle: "solid"
    },
    borderColor: "primary.200",
    borderWidth: "2px",
    borderStyle: "dashed"
  },
  dropzoneFailed: {
    transition: "background-color 150ms ease-out",
    borderColor: "error.500",
    borderWidth: 1,
    _hover: {
      borderColor: "error.500",
      borderStyle: "solid",
      backgroundColor: "neutral.100"
    }
  },
  dropdzoneFailedDrag: {
    transition: "background-color 150ms ease-out",
    borderColor: "error.500",
    borderWidth: 1,
    backgroundColor: "primary.50",
    _hover: {
      backgroundColor: "primary.50"
    }
  },
  errorMessage: {
    paddingX: "spacing-200",
    paddingY: "spacing-100",
    color: "primary.700",
    fontSize: "md",
    lineHeight: "4.824"
  },
  errorMessageContainer: {
    padding: "spacing-50",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    backgroundColor: "error.100",
    opacity: 0,
    animation: "fade-in 150ms ease-out forwards",
    "@keyframes fade-in": { "0%": { opacity: 0 }, "100%": { opacity: 1 } }
  },
  heading: {
    fontSize: "lg",
    color: "primary.700",
    lineHeight: "5.5",
    textAlign: "center"
  },
  icon: {
    width: "size-400",
    height: "size-400"
  },
  or: {
    marginX: "spacing-50"
  },
  root: {
    height: "full"
  },
  spinnerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "spacing-100",
    flexDirection: "column",
    // spinner
    div: {
      width: "size-400",
      height: "size-400"
    }
  }
}), l = o({
  baseStyle: n
});
export {
  l as FileUploader,
  n as baseStyle
};
//# sourceMappingURL=FileUploader.es.js.map
